
import { Component, Prop } from 'vue-property-decorator'
import Mixin from '../helpers/mixin'
import { IDownload } from '../store/modules/request-download'

interface ICategory {
  anchorLinkText: string
  title: string
  introduction: string
  downloadElements: IDownload[]
}

@Component({})
export default class Downloads extends Mixin {
  @Prop() headerHeight: number

  @Prop() categories: ICategory[]

  search: string | null = null

  openCategoryIndex: number | null = null

  get filteredCategories(): ICategory[] {
    if (!this.search) return this.categories
    const search = this.search.toLowerCase()

    const categoriesWithFilteredDownloads = this.categories.map(category => {
      const downloadElements = category.downloadElements.filter(download => download.title.toLowerCase().includes(search) ||
        download.fileName && download.fileName.toLowerCase().includes(search))

      return { ...category, downloadElements }
    })

    return categoriesWithFilteredDownloads.filter(category => category.downloadElements.length > 0)
  }


  get searchResultsAmount(): number{
    return this.filteredCategories.map(category => category.downloadElements).flat().length
  }


  clearSearch(): void {
    this.search = null
  }

  openCategory(index: number): void {
    // wait for scroll before opening the downloads
    // otherwise the title of the category is not scrolled to the top
    setTimeout(() => this.openCategoryIndex = index, 300);
  }

  toggleCategory(index: number): void {
    this.openCategoryIndex = this.openCategoryIndex === index ? null : index
  }

  downloadFile(download: IDownload, form: any): void {
    const downloadUrl = download.fileUrl && download.fileUrl.length ? download.fileUrl : download.file

    if (download.requiresUserInformation && form) this.$store.commit('requestDownload/open', {download, form})

    else if (downloadUrl.length) {
      const link = document.createElement('a')
      link.href = downloadUrl
      link.download = download.fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
